module.exports = __webpack_public_path__ + "img/cert19.8132dbd9.png";